{
  "linkTo": "Définir le chemin",
  "parkingSpotWithNumber": "Tache {{number}}",
  "pathNotSetWarning": "Chemin linéaire non configuré. Définissez un chemin pour activer les fonctionnalités de suivi de déplacement linéaire.",
  "setLinearPath": "Définir un chemin linéaire",
  "stageParkingSpots": {
    "cancelText": "Dos",
    "instructions": "Définissez les places de stationnement sur le chemin de la station de base.",
    "title": "Places de parking"
  },
  "stagePathEnd": {
    "cancelText": "Dos",
    "instructions": "Définissez le point final du chemin de la station de base en appuyant sur la carte.",
    "title": "Point final"
  },
  "stagePathStart": {
    "cancelText": "Annuler",
    "instructions": "Définissez le point de départ du chemin de la station de base en appuyant sur la carte.",
    "title": "Point de départ"
  },
  "stageSwath": {
    "cancelText": "Dos",
    "instructions": "Réglez la largeur de l'andain. Appuyez sur « Inverser » pour inverser le sens de l'andain.",
    "title": "Andain"
  },
  "title": "Définir un chemin de déplacement linéaire"
}
